/* Procedural scenery: blue sky with clouds and a realistic lawn. No external images. */
window.PCScenery = function (THREE, scene, camera, renderer) {
  var seed = 11;
  function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
  function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }

  camera.far = 400;
  camera.updateProjectionMatrix();
  scene.fog = new THREE.Fog(0xd6e6f2, 60, 240);

  /* Sky dome with soft clouds */
  var sc = canvas(1024, 512), sg = sc.getContext('2d');
  var grad = sg.createLinearGradient(0, 0, 0, 256);
  grad.addColorStop(0, '#2b69b3');
  grad.addColorStop(0.45, '#6ea5d9');
  grad.addColorStop(1, '#d6e6f2');
  sg.fillStyle = grad; sg.fillRect(0, 0, 1024, 256);
  sg.fillStyle = '#d6e6f2'; sg.fillRect(0, 256, 1024, 256);
  for (var i = 0; i < 26; i++) {
    var cx = rnd() * 1024, cy = 60 + rnd() * 140, puffs = 7 + Math.floor(rnd() * 7);
    for (var j = 0; j < puffs; j++) {
      var px = cx + (rnd() - 0.5) * 150, py = cy + (rnd() - 0.5) * 22, r = 22 + rnd() * 34;
      var rg = sg.createRadialGradient(px, py, 0, px, py, r);
      rg.addColorStop(0, 'rgba(255,255,255,0.55)');
      rg.addColorStop(1, 'rgba(255,255,255,0)');
      sg.fillStyle = rg;
      sg.beginPath(); sg.ellipse(px, py, r * 1.6, r * 0.7, 0, 0, 6.283); sg.fill();
    }
  }
  var skyMat = new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), side: THREE.BackSide, fog: false, depthWrite: false });
  var sky = new THREE.Mesh(new THREE.SphereGeometry(300, 40, 20), skyMat);
  sky.renderOrder = -1;
  scene.add(sky);

  /* Lawn: dense blade-level texture (tiles every 7 m) */
  var T = 1024, gc = canvas(T, T), gg = gc.getContext('2d');
  gg.fillStyle = '#4c7a2b'; gg.fillRect(0, 0, T, T);
  var tones = [
    'rgba(28,62,20,0.55)', 'rgba(40,84,28,0.55)', 'rgba(62,108,34,0.5)', 'rgba(84,132,42,0.5)',
    'rgba(112,158,56,0.45)', 'rgba(142,178,70,0.4)', 'rgba(176,190,86,0.28)'
  ];
  for (var k = 0; k < 60000; k++) {
    var x = rnd() * T, y = rnd() * T;
    var ang = -Math.PI / 2 + (rnd() - 0.5) * 1.3, len = 5 + rnd() * 10;
    var ex = x + Math.cos(ang) * len, ey = y + Math.sin(ang) * len;
    gg.strokeStyle = tones[Math.floor(Math.pow(rnd(), 1.3) * tones.length)];
    gg.lineWidth = 0.8 + rnd() * 1.2;
    gg.beginPath(); gg.moveTo(x, y);
    gg.quadraticCurveTo(x + (rnd() - 0.5) * 6, (y + ey) / 2, ex, ey);
    gg.stroke();
  }
  var gt = new THREE.CanvasTexture(gc);
  gt.wrapS = gt.wrapT = THREE.RepeatWrapping;
  gt.repeat.set(100, 100);
  try { gt.anisotropy = renderer.capabilities.getMaxAnisotropy(); } catch (e) {}
  var ground = new THREE.Mesh(
    new THREE.PlaneGeometry(700, 700),
    new THREE.MeshStandardMaterial({ map: gt, bumpMap: gt, bumpScale: 1.2, roughness: 1, metalness: 0 })
  );
  ground.rotation.x = -Math.PI / 2;
  ground.position.y = -0.002;
  ground.receiveShadow = true;
  scene.add(ground);

  /* Large-scale variation: soft patches and subtle mowing stripes (breaks up tiling) */
  var M = 512, mc = canvas(M, M), mg = mc.getContext('2d');
  var bands = 12;
  for (var b = 0; b < bands; b++) {
    mg.fillStyle = b % 2 ? 'rgba(255,255,220,0.07)' : 'rgba(0,30,0,0.07)';
    mg.fillRect(b * (M / bands), 0, M / bands, M);
  }
  for (var p = 0; p < 55; p++) {
    var bx = rnd() * M, by = rnd() * M, br = 30 + rnd() * 90, dark = rnd() < 0.5;
    var rg2 = mg.createRadialGradient(bx, by, 0, bx, by, br);
    rg2.addColorStop(0, dark ? 'rgba(20,55,15,0.16)' : 'rgba(190,205,110,0.14)');
    rg2.addColorStop(1, 'rgba(0,0,0,0)');
    mg.fillStyle = rg2; mg.beginPath(); mg.arc(bx, by, br, 0, 6.283); mg.fill();
  }
  var mt = new THREE.CanvasTexture(mc);
  mt.wrapS = mt.wrapT = THREE.RepeatWrapping;
  mt.repeat.set(14, 14);
  var macro = new THREE.Mesh(
    new THREE.PlaneGeometry(700, 700),
    new THREE.MeshBasicMaterial({ map: mt, transparent: true, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -1, polygonOffsetUnits: -1 })
  );
  macro.rotation.x = -Math.PI / 2;
  macro.position.y = 0.002;
  scene.add(macro);
};